import "../../constants/layout.js";
import { uuid25 } from "../../uuid/dist/uuid25.js";
import { deepMerge } from "../deepMerge.js";
//#region src/utils/collection/memo.entity.ts
var createMemo = (value) => deepMerge({
	id: uuid25(),
	value: "",
	ui: {
		x: 200,
		y: 100,
		zIndex: 2,
		width: 116,
		height: 100,
		color: ""
	}
}, value ?? {});
//#endregion
export { createMemo };
